module.exports = __webpack_public_path__ + "img/tablet-screen-button.29975f45.svg";